import React, { useState, useEffect } from 'react';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,
  TablePagination, Button, Checkbox, Menu, MenuItem, IconButton, TextField
} from '@material-ui/core';
import { saveAs } from 'file-saver';
import SaveAltIcon from '@material-ui/icons/SaveAlt';
import { Prompt } from 'react-router';
import ActivityPlanned from "./ActivityPlanned";
import { getProfessionalType } from "../../services/master-tables.service";
import { useGetIdentity } from "ra-core";
import FilterListIcon from '@material-ui/icons/FilterList';

import CloseIcon from '@material-ui/icons/Close';


const days = ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"];

const exportableColumns = [
  {
    id: 'name',
    label: 'Nombre de Actividad',
    export: true,
    getValue: (row) => row.name
  },
  {
    id: 'description',
    label: 'Descripción',
    export: true,
    getValue: (row) => row.description
  },
  {
    id: 'typologyName',
    label: 'Tipo',
    export: true,
    getValue: (row) => row.typologyName
  },
  {
    id: 'subtypologyName',
    label: 'SubTipología',
    export: true,
    getValue: (row) => row.subtypologyName
  },
  {
    id: 'professionalName',
    label: 'Profesional',
    export: true,
    getValue: (row) => row.professionalName
  },
  {
    id: 'duration',
    label: 'Duración (h)',
    export: true,
    getValue: (row) => row.duration + 'h'
  },
  {
    id: 'startTime',
    label: 'Hora',
    export: true,
    getValue: (row) => row.startTime
  },
  {
    id: 'day',
    label: 'Día',
    export: true,
    getValue: (row) => days[row.day]
  },
  {
    id: 'contracts',
    label: 'Contratos',
    export: true,
    getValue: (row) => row.contracts?.map(c => c.contractNumber).join(',')
  },
  {
    id: 'participants',
    label: 'Participantes',
    export: true,
    getValue: (row) => row.participants?.map(c => `${c.name} ${c.surnames}`).join(',')
  },
  {
    id: 'error',
    label: 'Error',
    export: true,
    getValue: (row) => row.error
  }
];

export const ActivitiesTable = props => {

  const { plannedActivities, isGroup, editingActivity, setEditingActivity, nameCSV } = props;
  const [filterMenuAnchorEl, setFilterMenuAnchorEl] = useState(null);

  const [visibleFilterFields, setVisibleFilterFields] = useState([]);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [selectedIds, setSelectedIds] = useState([]);
  const [activities, setActivities] = useState(plannedActivities.filter(f => isGroup ? f.typologyName === "Grupal" : f.typologyName === "Individual"));
  const [professionalTypes, setprofessionalTypes] = useState()
  const { identity } = useGetIdentity();

  const [orderBy, setOrderBy] = useState('');
  const [order, setOrder] = useState('asc');
  const [filters, setFilters] = useState({
    name: '',
    subtypologyName: '',
    day: '',
    startTime: '',
    duration: '',
    professionalName: '',
  });



  const filterableColumns = [
    { id: 'name', label: 'Nombre' },
    { id: 'subtypologyName', label: 'Tipo' },
    { id: 'day', label: 'Día' },
    { id: 'startTime', label: 'Hora' },
    { id: 'duration', label: 'Duración' },
    { id: 'professionalName', label: 'Profesional' }
  ];


  useEffect(() => {

    getProfessionalType().then(
      res => {
        setprofessionalTypes(res.elements);
      }
    )

  }, []);


  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };


  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSort = (columnId) => {
    const isAsc = orderBy === columnId && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(columnId);
  };

  const isSelected = (id) => selectedIds.includes(id);

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelectedIds = paginatedData.map((act) => act.id);
      setSelectedIds(newSelectedIds);
    } else {
      setSelectedIds([]);
    }
  };

  const handleClick = (id) => {
    const selectedIndex = selectedIds.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = [...selectedIds, id];
    } else {
      newSelected = selectedIds.filter((selectedId) => selectedId !== id);
    }

    setSelectedIds(newSelected);
  };



  const exportToCSV = () => {
    const selectedColumns = exportableColumns.filter(col => col.export);
    const header = selectedColumns.map(col => col.label);
    const csvRows = [
      header.join(';'),
      ...paginatedData.map(row =>
        selectedColumns.map(col => {
          const cell = col.getValue(row);
          return `"${(cell ?? '').toString().replace(/"/g, '""')}"`;
        }).join(';')
      )
    ];

    const BOM = '\uFEFF';
    const csvString = BOM + csvRows.join('\r\n');
    const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
    saveAs(blob, `${nameCSV}.csv`);
  };

  const handleSaveActivity = (updatedActivity) => {

    if(updatedActivity){
      const updated = activities?.map((act) =>
      act.id === updatedActivity.id ? updatedActivity : act
    );
    setActivities(updated);
    setEditingActivity(null);
    }
    
  };

  const filteredActivities = activities.filter(act => {
    return Object.entries(filters).every(([key, value]) => {
      if (!value) return true;
      if (key === 'day') {
        return days[act.day].toLowerCase().includes(value.toLowerCase());
      }
      return act[key]?.toString().toLowerCase().includes(value.toLowerCase());
    });
  });

  const sortedActivities = filteredActivities.sort((a, b) => {
    const aValue = a[orderBy] ?? '';
    const bValue = b[orderBy] ?? '';
    if (orderBy === '') return 0;
    return order === 'asc'
      ? aValue.toString().localeCompare(bValue.toString())
      : bValue.toString().localeCompare(aValue.toString());
  });

  const paginatedData = sortedActivities.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );


  return (
    <>

      <Prompt
        when={!editingActivity}
        message="Las propuestas de actividades programadas se perderán. ¿Seguro que quieres salir?"
      />


      {!editingActivity ? (
        <Paper style={{ padding: '1rem', borderRadius: '30px' }}>
          <div className="div-planned">
            <span style={{ fontSize: '1.6rem', fontWeight: 'bold' }}>{isGroup ? "Actividades Grupales" : "Actividades Individuales"}</span>
            <span>Propuesta de actividades programadas:</span>
          </div>
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '1rem', marginRight: '1rem' }}>
              <Button
                variant="outlined"
                startIcon={<FilterListIcon />}
                onClick={(e) => setFilterMenuAnchorEl(e.currentTarget)}
              >
                Añadir Filtro
              </Button>
              <Menu
                anchorEl={filterMenuAnchorEl}
                open={Boolean(filterMenuAnchorEl)}
                onClose={() => setFilterMenuAnchorEl(null)}
              >
                {filterableColumns.map(col => (
                  <MenuItem
                    key={col.id}
                    onClick={() => {
                      console.log('Click en filtro', col.id);
                      setVisibleFilterFields(prev => {
                        if (!prev.includes(col.id)) {
                          return [...prev, col.id];
                        }
                        return prev;
                      });
                      setFilterMenuAnchorEl(null);
                    }}


                  >
                    {col.label}
                  </MenuItem>
                ))}
              </Menu>
            </div>
            <Button
              variant="contained"
              color="primary"
              startIcon={<SaveAltIcon />}
              onClick={exportToCSV}
            >
              Exportar CSV
            </Button>
          </div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem', marginBottom: '1rem' }}>
            {visibleFilterFields.map(field => {
              const label = filterableColumns.find(c => c.id === field)?.label;
              return (
                <TextField
                  key={field}
                  label={label}
                  value={filters[field] || ''}
                  onChange={(e) => setFilters({ ...filters, [field]: e.target.value })}
                  variant="outlined"
                  size="small"
                  style={{ width: '250px' }} // Ajuste compacto
                  InputProps={{
                    endAdornment: (
                      <IconButton size="small" onClick={() => {
                        const updated = { ...filters };
                        delete updated[field];
                        setFilters(updated);
                        setVisibleFilterFields(visibleFilterFields.filter(f => f !== field));
                      }}>
                        <CloseIcon fontSize="small" />
                      </IconButton>
                    )
                  }}
                />
              );
            })}
          </div>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell padding="checkbox">
                    <Checkbox
                      indeterminate={
                        selectedIds.length > 0 && selectedIds.length < paginatedData.length
                      }
                      checked={
                        paginatedData.length > 0 &&
                        selectedIds.length === paginatedData.length
                      }
                      onChange={handleSelectAllClick}
                    />
                  </TableCell>
                  <TableCell onClick={() => handleSort('name')} style={{ cursor: 'pointer' }}>
                    Nombre {orderBy === 'name' ? (order === 'asc' ? '⬆' : '⬇') : ''}
                  </TableCell>
                  <TableCell onClick={() => handleSort('subtypologyName')} style={{ cursor: 'pointer' }}>
                    Tipo {orderBy === 'subtypologyName' ? (order === 'asc' ? '⬆' : '⬇') : ''}
                  </TableCell>
                  <TableCell onClick={() => handleSort('day')} style={{ cursor: 'pointer' }}>
                    Día Habitual {orderBy === 'day' ? (order === 'asc' ? '⬆' : '⬇') : ''}
                  </TableCell>
                  <TableCell onClick={() => handleSort('startTime')} style={{ cursor: 'pointer' }}>
                    Hora Habitual {orderBy === 'startTime' ? (order === 'asc' ? '⬆' : '⬇') : ''}
                  </TableCell>
                  <TableCell onClick={() => handleSort('duration')} style={{ cursor: 'pointer' }}>
                    Duración {orderBy === 'duration' ? (order === 'asc' ? '⬆' : '⬇') : ''}
                  </TableCell>
                  <TableCell onClick={() => handleSort('professionalName')} style={{ cursor: 'pointer' }}>
                    Profesional {orderBy === 'professionalName' ? (order === 'asc' ? '⬆' : '⬇') : ''}
                  </TableCell>
                  <TableCell>Contratos</TableCell>
                  <TableCell>Participantes</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {paginatedData?.map((act, idx) => {
                  const isItemSelected = isSelected(act.id);

                  return (
                    <TableRow
                      key={act.id}
                      hover
                      selected={isItemSelected}
                      role="checkbox"
                      aria-checked={isItemSelected}
                      //onClick={() => handleClick(act.id)}
                      onClick={(e) => {
                        if (e.target.type !== 'checkbox') {
                          setEditingActivity(act);
                        }
                      }}
                      style={{ cursor: 'pointer' }}
                    >
                      <TableCell padding="checkbox" onClick={(e) => e.stopPropagation()}>
                        <Checkbox
                          checked={isSelected(act.id)}
                          onChange={() => handleClick(act.id)}
                        />
                      </TableCell>
                      <TableCell>{act.name}</TableCell>
                      <TableCell>{act.subtypologyName}</TableCell>
                      <TableCell>{days[act.day]}</TableCell>
                      <TableCell>{act.startTime}</TableCell>
                      <TableCell>{act.duration}h</TableCell>
                      <TableCell>{act.professionalName}</TableCell>
                      <TableCell>{act.contracts?.slice(0, 3).map((contract, index) => (
                        <div key={contract.id}>
                          {contract.contractNumber}
                        </div>
                      ))}
                        {act.contracts?.length > 3 && <div>...</div>}
                      </TableCell>
                      <TableCell>{act.participants?.slice(0, 3).map((client, index) => (
                        <div key={client.id}>
                          {client.name + ' ' + client.surnames}
                        </div>
                      ))}
                        {act.participants?.length > 3 && <div>...</div>}
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            component="div"
            rowsPerPageOptions={[5, 10, 20, 50, 100]}
            count={activities?.length ?? 0}
            page={page}
            onChangePage={handleChangePage}
            rowsPerPage={rowsPerPage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
            labelRowsPerPage="Filas por página:"
            labelDisplayedRows={({ from, to, count }) => `${from}–${to} de ${count}`}
          />
          <div style={{ marginTop: '1rem', display: 'flex', gap: '1rem', justifySelf: 'end', paddingTop: '1rem' }}>
            <Button disabled={!selectedIds.length > 0} style={{ width: '10rem', height: '2.5rem' }} variant="contained" color="primary">Validar</Button>
          </div>
        </Paper>
      ) : (
        <Paper style={{ padding: '2rem', borderRadius: '30px' }}>
          <h2>Editar Actividad planificada - {editingActivity.name}</h2>

          <ActivityPlanned
            props={props}
            editingActivity={editingActivity}
            setEditingActivity={setEditingActivity}
            onSave={handleSaveActivity}
            professionalTypes={professionalTypes}
            identity={identity}
          />
        </Paper>
      )}



    </>
  );
}
export default ActivitiesTable;